import { useOptimisticBookingState, useRealTime } from '@core/hooks';
import { useReservationTimelineParams } from '@core/hooks/useReservationParams';
import { useEffect, useState } from 'react';
import { INACTIVE_TIME, cellSize, cellXSpacing, hoursOfDayColor } from './defaults';
import { MIDDLE_STYLE } from '@constants/responsive';
import { GLOBAL_THEME_COLOR } from '@constants/theme';
import RenderTimelineTrackerComponent from './RenderTimelineTrackerComponent';
import { Space } from 'antd';
import { getFormattedTimeFromIndex } from '@utils/date.util';

const RenderTimelineHeaderComponents = () => {
  const { isInCurrentHour } = useRealTime();
  const { bookingSetting } = useOptimisticBookingState();
  const [headerComponents, setHeaderComponents] = useState<React.ReactNode[]>([]);
  const { selectedDayReservationQueue } = useReservationTimelineParams();

  useEffect(() => {
    const components: React.ReactNode[] = [];
    for (
      let hour = bookingSetting.open_hour;
      hour < bookingSetting.closed_hour + INACTIVE_TIME;
      hour++
    ) {
      components.push(
        <div style={{ width: cellSize, position: 'relative' }}>
          <div
            style={{
              width: '100%',
              backgroundColor: hoursOfDayColor(
                hour,
                bookingSetting.open_hour,
                bookingSetting.closed_hour
              ),
              fontWeight: '700',
              padding: '3px 0px',
              ...MIDDLE_STYLE,
            }}>
            {getFormattedTimeFromIndex(hour)}
          </div>
          <div
            style={{
              color: GLOBAL_THEME_COLOR.$dark_text_color,
              padding: '10px 0px',
              ...MIDDLE_STYLE,
            }}>
            {hour < bookingSetting.open_hour || hour >= bookingSetting.closed_hour
              ? 'Closed'
              : `${selectedDayReservationQueue[hour - bookingSetting.open_hour]?.length}/
            ${bookingSetting.max_number_of_people}`}
          </div>
          {isInCurrentHour(hour) && <RenderTimelineTrackerComponent />}
        </div>
      );
    }
    setHeaderComponents(components);
  }, [bookingSetting, isInCurrentHour]);

  return (
    <Space size={cellXSpacing} style={{ display: 'flex' }}>
      {headerComponents}
    </Space>
  );
};

export default RenderTimelineHeaderComponents;
